<template lang="html">
  <div class="commentPersonList">
    <commentPersonItem
      v-for="comment in items"
      :comment="comment"
      :key="comment.id"
    ></commentPersonItem>
  </div>
</template>

<script>
import commentPersonItem from './commentPersonItem'

export default {
  props: {
    items: {
      type: Array,
      default() {
        return []
      }
    }
  },
  components: {
    commentPersonItem
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.commentPersonList {
  min-height: 100%;
  padding: 0 rem(36px);
  background-color: #fff;
  overflow-x: hidden;
  border-radius: rem(20px) rem(20px) 0 0;
}
</style>
